import React from 'react';
import './NotFound.css';
import PageContainer from '../../common/components/Page/PageContainer';

const NotFound = (props) => {
  {
    return props.asPage != undefined && props.asPage == true ? (
      <PageContainer pageName="not-found">
        <div
          className="u-fx u-fx-column u-fx-align-center u-fx-justify-center"
          qaTag="page-not-found"
        >
          <p>Ups! 404 Not Found.</p>
        </div>
      </PageContainer>
    ) : (
      <div
        className="u-fx u-fx-column u-fx-align-center u-fx-justify-center"
        qaTag="page-not-found"
      >
        <p>Ups! 404 Not Found.</p>
      </div>
    );
  }
};

export default NotFound;
